<template>
    <router-link class="shop" tag="div" :to="{name: 'shop', params: {id: shop.id, location: location}, query: shopQuery}">
        <div class="info">
            <div class="header">
                <div class="title">
                    <img v-if="getShopLogoUrl(shop)" :src="getShopLogoUrl(shop)">
                    {{ shop.is_brand ? shop.brand.name : shop.alias }}
                </div>
                <div class="favorite">
                    <img v-show="shop.is_favorite" src="@/assets/img/heart-active.svg" @click.stop="deleteFavorite(shop)">
                    <img v-show="!shop.is_favorite" src="@/assets/img/heart.svg" @click.stop="addFavorite(shop)">
                </div>
            </div>
            <div class="slogan">
                {{ fullAddress }}
            </div>
            <div class="status">
                <div class="work">
                    <div class="distance"><img src="@/assets/img/time3.svg">{{ shop.work }}</div>
                </div>
                <div class="self" v-if="shop.is_self">
                    店家自營
                </div>
            </div>
        </div>
        <div class="images">
            <div class="photo" v-for="photo in photos" :key="photo.id" :class="{'three': photos.length === 3}">
                <div class="content" :style="{ 'background-image': 'url(' + photo.url + ')'}" :class="{'one': photos.length === 1}"></div>
            </div>
        </div>
    </router-link>
</template>

<script>
    import * as apis from '../../apis';

    export default {
        name: 'Item',
        props: {
            shop: {
                required: true
            },
            location: {
                required: true,
            }
        },
        computed: {
            shopQuery() {
                let query = {
                    latitude: this.location.latitude || 0,
                    longitude: this.location.longitude || 0,
                };

                if (this.$route.query.action) {
                    query.action = this.$route.query.action;
                }

                return query;
            },
            photos() {
                return this.shop.photos.slice(0, 3);
            },
            fullAddress() {
                return (this.shop.district + this.shop.road + this.shop.additional) || '';
            }
        },
        methods: {
            getShopLogoUrl(shop) {
                if (shop.logo) {
                    return shop.logo.url;
                }

                if (shop.brand && shop.brand.photo) {
                    return shop.brand.photo.url;
                }

                return null;
            },
            addFavorite(shop) {
                shop.is_favorite = true;
                apis.addFavorite(shop.id);
            },
            deleteFavorite(shop) {
                shop.is_favorite = false;
                apis.deleteFavorite(shop.id);
            },
        }
    };
</script>

<style lang="scss" scoped>
    .shop {
        margin: 10px 0;
        padding: 15px;
        border-radius: 5px;
        box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);

        .info {
            .header {
                display: flex;
                justify-content: space-between;

                .title {
                    display: flex;
                    align-items: center;
                    color: #000000;
                    font-family: "PingFang TC";
                    font-size: 16px;

                    img {
                        height: 23px;
                        width: 23px;
                        border-radius: 90px;
                        margin-right: 5px;
                    }
                }
            }

            .favorite {
                img {
                    height: 15px;
                }
            }

            .slogan {
                margin-top: 5px;
                color: #4A4A4A;
                font-size: 12px;
            }

            .work {
                display: flex;
                margin-top: 5px;

                .distance {
                    color: #787878;
                    font-family: "PingFang TC";
                    font-size: 12px;
                    line-height: 17px;
                    white-space: pre-wrap;
                    height: 17px;
                    overflow: hidden;
                    display: flex;
                    justify-content: flex-start;

                    img {
                        margin-right: 3px;
                    }
                }

                .score {
                    margin-left: 8px;
                    color: #339933;
                    font-size: 12px;
                    display: flex;
                    align-items: center;
                }
            }
        }

        .self {
            color: #4A4A4A;
            font-family: "PingFang TC";
            font-size: 12px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 17px;
            text-align: center;
            border-radius: 9.5px;
            background-color: #EEEEEE;
            padding: 1px 10px;
        }

        .status {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .images {
            display: flex;

            .photo {
                flex: 1;

                &:not(:first-child) {
                    margin-left: 4px;
                }

                &:first-child {
                    border-bottom-left-radius: 5px;
                }

                &:last-child {
                    border-bottom-right-radius: 5px;
                }

                .content {
                    margin: 15px .5% 0 .5%;
                    padding-bottom: 100%;
                    background-position: center;
                    background-size: cover;
                    border-bottom-left-radius: inherit;
                    border-bottom-right-radius: inherit;

                    &.one {
                        padding-bottom: 50%;
                    }
                }
            }
        }
    }
</style>
